import React from "react";

import ColumnSettingsMenu from "./ColumnSettingsMenu";
import { useGridContext } from "./GridContext";

function GridSettingsButton({ className }: { className?: string }) {
  const { columns, hiddenFields, toggleHidden } = useGridContext();
  return (
    <ColumnSettingsMenu
      className={className}
      columns={columns}
      hiddenFields={hiddenFields}
      onToggleHidden={toggleHidden}
    />
  );
}

export default GridSettingsButton;
